// @flow
import { styled } from 'mz-ui-kit'

export const Option = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  fontSize: '14px',
})

export const IconWrapper = styled('div', {
  flexShrink: 0,
})

export const PlaceInfo = styled('div', {
  display: 'flex',
  flexFlow: 'column nowrap',
  flexGrow: 1,
  marginLeft: '8px',
})

export const PlaceTypeLabel = styled<{
  $favourite?: boolean,
}>('div', ({ $palette, $favourite }) => ({
  fontWeight: 'bold',
  color: $favourite ? `${$palette('TEXT')}` : `${$palette('GRAY').darken(17)}`,
}))
